import { balanceResultValidate } from "../../application/dtos/balance_result_validate";

export class BalanceResultEntity {
    constructor({file}){
        this.file = file
    }

    isValid() {
        return balanceResultValidate(this);
    }
}